import { Component, OnInit, Input, OnChanges, ElementRef } from '@angular/core';
import { GridsterConfig, GridsterItem } from 'angular-gridster2';

@Component({
  selector: 'plr-tile',
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.scss']
})
export class TileComponent implements OnInit, OnChanges {

  @Input() columns?: number;
  @Input() rows?: number;

  constructor(private elementRef: ElementRef) { }
  
  ngOnInit() {
  }

  ngOnChanges() {
  }

  setFocus() {
    this.elementRef.nativeElement.querySelector('h2').focus();
  }

}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/components/tile.component.ts